import { FunctionComponent } from 'react';
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@mui/material';
import clsx from 'clsx';

type Props = MuiButtonProps & {
  label?: string;
  width?: string | number;
  icon?: React.ReactNode;
  iconPosition?: 'start' | 'end';
};

const Button: FunctionComponent<Props> = ({
  label,
  className,
  width,
  sx,
  icon,
  iconPosition = 'start',
  children,
  ...props
}) => {
  return (
    <MuiButton
      className={clsx('button', className)}
      sx={{ ...(width !== undefined ? { width } : {}), ...sx }}
      variant='text'
      disableElevation
      {...props}
    >
      <span
        className='base'
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px', // optional spacing
        }}
      >
        {icon && iconPosition === 'start' && (
          <span
            className='button-icon'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </span>
        )}

        <span className='button2' style={{color: 'inherit'}}>{label}</span>

        {icon && iconPosition === 'end' && (
          <span className='button-icon'>{icon}</span>
        )}
      </span>

      {children}
    </MuiButton>
  );
};

export default Button;
